import { Link } from "react-router-dom";
import type { VideoItem } from "@/mocks/data";

interface VideoCardProps {
  video: VideoItem;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block rounded-xl overflow-hidden bg-gray-900/80 border border-gray-800/50 hover:border-amber-500/50 transition-all duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={video.thumbnail}
          alt={video.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          width={640}
          height={360}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-950/90 via-transparent to-transparent"></div>

        {video.isHot && (
          <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-amber-500 text-[10px] font-bold text-black">
            热门
          </div>
        )}

        <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-black/70 text-[10px] text-amber-400 font-medium">
          {video.rating}
        </div>

        <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between">
          <span className="text-[10px] text-white bg-black/60 px-1.5 py-0.5 rounded">
            {video.updateEpisode}
          </span>
          <span className="text-[10px] text-gray-300">{video.year}</span>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-amber-500/90 text-white shadow-lg shadow-amber-500/30">
            <i className="ri-play-fill text-xl ml-0.5"></i>
          </div>
        </div>
      </div>

      <div className="p-3">
        <h3 className="text-sm font-medium text-white line-clamp-1 group-hover:text-amber-400 transition-colors">
          {video.title}
        </h3>
        <div className="flex items-center gap-1.5 mt-1.5 flex-wrap">
          {video.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="text-[10px] text-gray-400 bg-gray-800/80 px-1.5 py-0.5 rounded">
              {tag}
            </span>
          ))}
          <span className="text-[10px] text-gray-500 ml-auto">{video.region}</span>
        </div>
      </div>
    </Link>
  );
}